module.exports = __webpack_public_path__ + "img/icon-social-twitter.5db80e81.svg";